import { Link } from "react-router-dom";
import { NavBar } from "../../components";
import "./LegalPage.css";

const Impressum = () => {
  return (
    <div className="legal-page">
      <NavBar isHomePage={false} />
      <main className="legal-content">
        <Link to="/" className="legal-back text-placeholder hover:text-primary">
          ← Back to home
        </Link>
        <h1>Impressum</h1>

        <h2>Unternehmensangaben</h2>
        <p>
          <strong>apptive GmbH</strong>
          <br />
          Zunzgerstrasse 44
          <br />
          4450 Sissach
          <br />
          Switzerland
        </p>

        <h2>Eintragung</h2>
        <p>
          Handelsregisteramt des Kantons Basel-Landschaft
          <br />
          Firmennummer: CH-280.4.026.102-7
          <br />
          UID / MWST: CHE-278.833.895
        </p>

        <h2>Kontakt</h2>
        <p>
          Telefon: +41 77 40 440 19
          <br />
          E-Mail: info@techbucket.ch
        </p>

        <h2>Haftung für Inhalte und Links</h2>
        <p>
          Wir erstellen die Inhalte dieser Website mit Sorgfalt. Für die
          Richtigkeit, Vollständigkeit und Aktualität können wir jedoch keine
          Gewähr übernehmen. Verpflichtungen zur Entfernung oder Sperrung der
          Nutzung von Informationen nach den allgemeinen Gesetzen bleiben davon
          unberührt. Für Inhalte verlinkter fremder Websites sind ausschliesslich
          deren Betreibende verantwortlich.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die durch apptive GmbH erstellten Inhalte und Werke auf dieser Website
          unterliegen dem Schweizer Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung oder jede Art der Verwertung ausserhalb der
          engen Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung
          der jeweiligen Rechtsinhaberin.
        </p>
      </main>
    </div>
  );
};

export default Impressum;
